import { useSWR, reqApiAgentIndexValidcodeenable } from '@/apis/ok'
import { useMemo } from 'react'

// 驗證碼相關邏輯 Hook
export const useValidCode = () => {
  const query = useSWR(`/validcodeenable`, reqApiAgentIndexValidcodeenable, {})

  // 是否啟用驗證碼
  const validCodeEnabled = useMemo(() => {
    return query.data?.t?.cfgValue === '1'
  }, [query.data])

  return {
    query,
    validCodeEnabled, // 是否啟用驗證碼
  }
}
